/* TELEPHONE : fond des photos produit rendu blanc pur directement dans l'image.
   Le fond gris clair des photos d'origine et le blanc "presque blanc" des photos importees
   (Amazon, fournisseurs...) deviennent exactement le meme blanc que la carte.
   Rendu identique sur iPhone (Safari) et Android : plus aucun double fond. */
(function(){try{
  if(!window.matchMedia('(max-width:1040px)').matches||!window.HTMLCanvasElement) return;
  var st=document.createElement('style');
  st.textContent='#contenu img.vc-wb,#panel img.vc-wb,img.vc-wb.vc-wb.vc-wb.vc-wb{filter:none!important;mix-blend-mode:normal!important}'+
    /* Vignettes : une fois le fond rendu blanc, la photo garde une petite marge (comme sur ordinateur) :
       les valises ne touchent plus les bords et l'etiquette promo ne les recouvre plus */
    '#contenu .card .img img.vc-wb{object-fit:contain!important;padding:7%!important}';
  document.head.appendChild(st);
  var SEL='img.ph-img,.card .img img,.size .img img,.col .img img,.dims .vis img,.duo .vis img,.duo .item img,.line img,.bb img,.xs img,.thumbs img,.gal img';
  function ok(img){return img.matches&&img.matches(SEL)&&!img.closest('.hero')&&!img.classList.contains('ph-bg');}
  function proc(img){try{
    if(!ok(img)) return;
    var src=img.currentSrc||img.src||'';
    if(!src||src.indexOf('blob:')===0||src.indexOf('data:')===0||img.dataset.wbDone===src) return;
    img.dataset.wbDone=src;
    if(new URL(src,location.href).origin!==location.origin){
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){paint(img,im,src);}; im.src=src; return;
    }
    paint(img,img,src);
  }catch(e){}}
  function paint(img,from,src){try{
    var w=from.naturalWidth,h=from.naturalHeight; if(!w||!h) return;
    var s=Math.min(1,1200/Math.max(w,h)); w=Math.round(w*s); h=Math.round(h*s);
    var c=document.createElement('canvas'); c.width=w; c.height=h;
    var x=c.getContext('2d'); x.fillStyle='#FFFFFF'; x.fillRect(0,0,w,h); x.drawImage(from,0,0,w,h);
    var d=x.getImageData(0,0,w,h), p=d.data, K=1.07;
    for(var i=0;i<p.length;i+=4){
      var r=p[i]*K,g=p[i+1]*K,b=p[i+2]*K;
      /* tout ce qui est presque blanc devient blanc pur */
      if(r>=246&&g>=246&&b>=246){r=g=b=255;}
      p[i]=r>255?255:r; p[i+1]=g>255?255:g; p[i+2]=b>255?255:b;
    }
    x.putImageData(d,0,0);
    c.toBlob(function(bl){ if(!bl) return;
      if((img.currentSrc||img.src)!==src) return;
      var u=URL.createObjectURL(bl);
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.dataset.wbDone=u; img.classList.add('vc-wb'); img.src=u;
    },'image/jpeg',0.92);
  }catch(e){}}
  document.addEventListener('load',function(e){var t=e.target; if(t&&t.tagName==='IMG') proc(t);},true);
  function all(){document.querySelectorAll(SEL).forEach(function(i){if(i.complete&&i.naturalWidth) proc(i);});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',all); else all();
  window.addEventListener('load',all);
}catch(e){}})();
